import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import * as FileSaver from "file-saver";
import "./styles.css";
import * as XLSX from "xlsx";
import * as Excel from "exceljs";
/*import './App.css';*/
/*import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'*/
import { Multiselect } from "multiselect-react-dropdown";

import MultiSelectReact from "multi-select-react";
/*import Multiselect from 'multiselect-dropdown-react';
 */ import { Field, reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import MySelect from "../../../../shared/components/form/MySelect";
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
var url = window.location.hostname;
var port = window.location.port;
const options = [];
const optionsUser = [];
var rfqCheckedAll = {};
var zone_arr = [];
var aisles_arr = [];
var racks_arr = [];
var racks_aisle = [];

var options2 = [];

const options1 = [];


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();

    this.state = {
      showPassword: false,
      generated_stn_number: "",
      validProd: false,
      notvalidProd: false,
      options2: [],
      options1: [],
      loadingGRNData: false,
      from_bin_id: "",
      to_bin_id: "",
      cycleCountCancelModal: false,
      from_loc_data: [],
      to_loc_data: [],
      reasonData:[],
      showSTNNumber: false,
      checkLoader: false,
      successMessageModal: false,
      SelectedBins: [],
      genloading: false,
      selectedOptionRadio: "",
      enableCreateCycle: true,
      loadBinData: false,
      schemas: [],
      showFetchGRNData: false,
      successModal: false,
      loadingprintbtn: false,
      modalAssignUser: false,
      zoneDataVal: [],
      removeSelectedDate: false,
      showProdDetail: false,
      modalCancel: false,
      isChecked: false,
      showFailedItem: false,
      isCheckedData: {},
      FailedItems: [],
      grnNumber: "",
      grnValues: "",
      grnLineValue: "",
      selectedOptions: "",
      failedMessage: "",
      changeStatus: "",
      alertMessage: "",
      messageModal: false,
      messageModalCycle: false,
      modalReport: false,
      disabledSubmitBtn: false,
      modalfailedCycle: false,
      showDashboardData: true,
      showRack: false,
      showZone: false,
    showProcess:false,
    onSelectProcess:"",
      showAisle: false,
      showBinTable: false,
      modalfailed: false,
      checkedAll: false,
      rfqCheckedAll: {},
      rfqChecked: {},
      postsGRN: [],
      postsProduct: [],
      multiSelect: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsProduct: [],
      from_bin_data:[],
      to_bin_data: [],
      ErrorRowData: [],
      binData: [],
      options: [],
      newArrayData: [],
      newArrayData1: [],
      totalScanCount: "",
      selectedUser: {},
      showAssignButton: true,
      showPrintButton: false,
      showSubmitBtn: false,
      clearData: false,
      showSelectedBin: false,
      optionSelected: null,
      optionSelected1: null,
      optionSelected2: null,
      isdisableAssignBtn: true,
    isdisableBinAssignBtn: false,
      optionForBinAddressDropdown: [],
      showBinAddressDropdown: false,
      value: "0",
      selectedBinAddress: "",
      all_binaddress: [],
      dropdownInProgress: false,
      containerOnKeyDown: false,
    loading_overlay: false,
    };
  }




 
  failedToggleCancel = () => {
    this.setState({
      modalfailed: false,
    });

    //window.location.reload();
  }

  failedToggleCancelCycle = () => {
    this.setState({
      modalfailedCycle: false,
    });

    window.location.reload();
  }





  onConfrmStock = () => {
    var stock_ids = Array.prototype.map.call(this.state.postsProduct, function(item) { return item.id; }).join(",");
    addAnalytics('Stock Mov To Dmg/Exp', 'To Dmg/Exp Confirm Stock');

     API.get('/stock/confirmStockMovement?stock_movement_ids=' + stock_ids)

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        if(data[0].status === true){

          this.setState({
            validProd: true,
            notvalidProd: false,
            success_message: data[0].reason,
            showProdDetail: true
          })

          this.successMessageToggle();
          this.fetchStockData();

        }else{
          this.failedToggle();
          this.setState({
            validProd: false,
            notvalidProd: true,
            failedMessage: data[0].reason,
            showProdDetail: false
          })
        }

      

        
      })

      .then(async () => {
        

        
      });
  }

 

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }
     else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
    });

    localStorage.setItem("userName", username);
  }

  

  accessCookie = (cookieName) =>{
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie = (cname)  => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  messagetoggle = ()=> {
    this.setState({
      messageModal: true,
    });
  }

  messageToggleCycle=()=> {
    this.setState({
      messageModalCycle: true,
    });
  }

  toggleAssignUser =()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUser: !prevState.modalAssignUser,
      prod_code: "",
      mrp: "",
      validProd: false,
      notvalidProd: false,
      qty: "",
      reason: ""
    }));
  }

  successToggle=()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ successModal: !prevState.successModal }));
    window.location.reload();
  }

  successMessageToggle=()=> {
    this.setState((prevState) => ({ successMessageModal: !prevState.successMessageModal }));
  }


  failedToggle=()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
  }

  failedToggleCycle=()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalfailedCycle: !prevState.modalfailedCycle,
    }));
  }

  toggleAssignUserCycleCount =()=> {
    /*this.setState({
    messageModal: true,
  })*/
    this.setState((prevState) => ({
      modalAssignUserCycleCount: !prevState.modalAssignUserCycleCount,
    }));
  }

  onCreate = ()=>{
    addAnalytics('Stock Mov. To Dmg/Exp', 'Create STM No.');
     API.get('/stock/createStockMovementBatch')

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        if(data.status === true){
          this.setState({
            showSTNNumber: true,
            generated_stn_number: data.batch_id,
            enableCreateCycle: false
          })

        }else{
          this.setState({
            showSTNNumber: true,
            failedMessage: data.reason,
            generated_stn_number: data.batch_id,
            enableCreateCycle:false
          })
          this.failedToggle();
        }

      

        
      })

      .then(async () => {
        

        
      });

   
  }

  onHandleChange = (evt) =>{
    this.setState({[evt.target.name]: evt.target.value})
    if(evt.target.name == "to_loc"){
      if(evt.target.value == "4"){
        if(this.state.to_loc_data[0].zone_type == "4"){
          this.setState({
            to_bin_data: this.state.to_loc_data[0].bin_detail
          })
        }else{
          this.setState({
            to_bin_data: this.state.to_loc_data[1].bin_detail
          })
        }
        
      }else{
         if(this.state.to_loc_data[0].zone_type == "3"){
          this.setState({
            to_bin_data: this.state.to_loc_data[0].bin_detail
          })
        }else{
          this.setState({
            to_bin_data: this.state.to_loc_data[1].bin_detail
          })
        }
      }
    }
  }

   onHandleChangeBin = (evt) =>{
    this.setState({[evt.target.name]: evt.target.value})
    
  }


  

 

 

  fetchGRNData() {
    var grnVal = localStorage.getItem("grnValues");
    this.setState({
      showFetchGRNData: true,
      loadingGRNData: true,
    });

    const payload = {
    
  };

API.post('/picking/fetchgrnInfo/v1/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        this.setState({
          postsGRN: data,
          grnValues: data[0].grnNumber,
          grnLineValue: data[0].gnrLineNumber,
        });
        /*console.log(this.state.postsGRN[0].grnNumber)*/
      })

      .then(async () => {
        this.setState({
          tableRowsGRN: this.assemblePostsGRN(),
          isLoading: false,
          loadingGRNData: false,
        });

        console.log(this.state.tableRowsGRN);
      });
  }

  onSearchData =()=>{

   addAnalytics('Stock Mov To Dmg/Exp', 'To Dmg/Exp Validate Prod');

    API.get('/stock/searchProductStockMovement?prod_code=' + this.state.prod_code + '&mrp=' + this.state.mrp + '&request_type=good_to_dmg')

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        if(data.status === true){
          this.setState({
            validProd: true,
            notvalidProd: false,
            from_loc_data: data.from_loc,
            to_loc_data: data.to_loc,
            from_loc: data.from_loc[0].zone_type,
            to_loc: data.to_loc[0].zone_type,
            from_bin_data: data.from_loc[0].bin_detail,
            from_bin_id: data.from_loc[0].bin_detail[0].id,
            to_bin_id: data.to_loc[0].bin_detail[0].id,
            to_bin_data: data.to_loc[0].bin_detail,
            showProdDetail: true,

          })

        }else{
          this.setState({
            validProd: false,
            notvalidProd: true,
            showProdDetail: false
          })
        }

      

        
      })

      .then(async () => {
        

        
      });

  }

  assemblePostsGRN = () => {
    let postsGRN = this.state.postsGRN.map((post, index) => {
      return {
        serial: index + 1,

        /*grnNumber: post.grnNumber,

          gnrLineNumber: post.gnrLineNumber,*/

        /*putawayHistoryId: post.putawayHistoryId,*/
        /*status: post.status == 'UNHOLD' ? <MDBBtn onClick={r => this.btnClick(post.putawayHistoryId, post.status)} style={{backgroundColor: '#4ce1b6' , color: '#fff'}} color="default" rounded size="sm">Hold</MDBBtn> : <MDBBtn  style={{backgroundColor: '#de5361', color: '#fff'}} onClick={r => this.btnClick(post.putawayHistoryId, post.status)} rounded size="sm">Release</MDBBtn>,*/
        status:
          post.status == "UNHOLD" ? (
            <span
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
              style={{ color: "red", cursor: "pointer" }}
            >
              Hold
            </span>
          ) : (
            <span
              style={{ color: "green", cursor: "pointer" }}
              onClick={(r) => this.btnClick(post.putawayHistoryId, post.status)}
            >
              Unhold
            </span>
          ),

        binId: post.binId,

        zone_name: post.zoneName,

        zone_id: post.zoneId,

        lbskuid: post.lbSKUId,

        batch: post.batch,

        mrp: post.mrp,

        receivedIcldQuantity: post.receivedIcldQuantity,

        testerQuantity: post.testerQuantity,

        looseQuantity: post.looseQuantity,

        stnDate: post.stnDate,

        stnNumber: post.stnNumber,

        pkd: post.pkd,

        upc: post.upc,

        total_quantity: post.binFilledQty,

        /*grnDateTime: post.grnDateTime,*/

        /*basePackDesc: post.basePackDesc,*/

        fastMoving: post.fastMoving,

        crateId: post.crateId,
      };
    });

    return postsGRN;
  };

  fetchStockData = ()=> {
    const payload = {
      location: this.state.selectedLocation,
  };

API.get('/stock/fetchStockMovementData')

      .then((response) => response.data)

      .then((data) => {
        // console.log(data);

        // if (err) throw err;

        

        console.log(this.state.postsProduct);

        var filterPostData = [];

        filterPostData = data.filter((item) => item.status === "Active");

        console.log(filterPostData);

        if (filterPostData.length > 0) {
          this.setState({
            disabledSubmitBtn: true,
          });
        }

         let newDataVal = data.map((item) => ({
          ...item,
          error: "",
        }));
        this.setState({ postsProduct: newDataVal });
        
      })



      .then(async () => {
        this.setState({
          tableRowsProduct: this.assemblePostsProduct(),
          isLoading: false,
          genloading: false,
        });

        console.log(this.state.tableRowsProduct);
      });
  }

  addProduct =()=>{
    addAnalytics('Stock Mov To Dmg/Exp', 'To Dmg/Exp Add Prod');

    API.get('/stock/addProductStockMovement?prod_code=' + this.state.prod_code + '&mrp=' + this.state.mrp + '&qty=' + this.state.qty + '&reason_id=' + this.state.reason + '&from_zone_type=' +this.state.from_loc + '&to_zone_type=' + this.state.to_loc + '&from_bin_id=' + this.state.from_bin_id+ '&to_bin_id='+ this.state.to_bin_id)
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        if(data.status === true){
          this.successMessageToggle();
          this.setState({
            modalAssignUser: false,
            success_message: data.reason
          })
          this.fetchStockData();

        }else{
          this.failedToggle()
          this.setState({
            modalAssignUser: true,
            failedMessage: data.message
          })
          //this.fetchStockData();
        }

      

        
      })

      .then(async () => {
        

        
      });

  }

  getReason=() => {
    const payload = {
      location: this.state.selectedLocation,
      screen_type: "edit_ptl",
    };
    API.post("/product/product_master/v1/reason/dropdown/", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        console.log("REASON", data);
        this.setState({ reasonData: data.data });
      })

      .then(async () => {});
  }

  componentDidMount() {
    //this.fetchUserList();
    this.fetchStockData();
    this.getReason();
  }
  TaskConfirmClick = (id) => {
    localStorage.setItem('batch',id);window.location.href = "/maintenance/cycleCountConfirmation";
  };
  assemblePostsProduct = () => {
    console.log("cvbn");

    console.log(this.state.postsProduct);

    let postsProduct = this.state.postsProduct.map((post) => {
      return {
     
        prod_code: post.prod_code,
        prod_name: post.prod_name,

        mrp: post.mrp,

        from_loc: post.from_loc,

        to_loc: post.to_loc,

        qty: post.qty,
        action: <i style={{color: 'red', cursor: 'pointer'}}  onClick={(r) => this.onRemove(post.id)} class="fa fa-trash" aria-hidden="true"></i>

      };
    });

    return postsProduct;
  };


  onRemove(id){

     API.get('/stock/removeStockMovement?stock_movement_ids='+ id)

      .then((response) => response.data)

      .then((data) => {
        console.log(data);
        if(data.status === true){
          this.successMessageToggle();
          this.setState({
            modalAssignUser: false,
            success_message: data.reason
          })
          this.fetchStockData();

        }else{
          this.failedToggle()
          this.setState({
            modalAssignUser: false,
            failed_message: data.message
          })
          this.fetchStockData();
        }
      })
      .then(async () => {   
      });
  }



  toggle() {
    this.setState({
      selectedUser: {},
      selectedOptions: "",
      modal: true,
      newArrayData1: [],
    });

    /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
    var arrayCartData = this.state.postsGRN.filter(
      (item) => item.status === "UNHOLD" && item.zoneName != null
    );
    console.log(arrayCartData);
    this.setState({
      newArrayData1: arrayCartData,
    });
  }

  

  render() {
    const { handleSubmit, reset, t } = this.props;
    const {
      showPassword,
      newArrayData,
      newArrayData1,
      selectedUser,
      modalReport,
    } = this.state;
    const { modal, modalCancel } = this.state;
    const { modalAssignUser, modalAssignUserCycleCount, successMessageModal } = this.state;
    const {
      messageModal,
      modalfailed,
      successModal,
      modalfailedCycle,
      messageModalCycle,
      cycleCountCancelModal,
    } = this.state;
    const uniqueZoneData1 = {};
    const uniqueZoneData = {};
  

    const productData = {
      columns: [
    {
          label: "Prod Code",

          field: "prod_code",

          width: 110,
        },
        {
          label: "Prod Name",

          field: "prod_name",

          width: 130,
        },

        {
          label: "MRP",

          field: "mrp",

          width: 100,
        },

        {
          label: "From Loc",

          field: "from_loc",
          width: 110,
        },

        {
          label: "To Loc",

          field: "to_loc",
          width: 110,
        },

        {
          label: "Qty",

          field: "qty",

          width: 110,
        },

       /* {
          label: "Reason",

          field: "reason",

          width: 120,
        },*/

        {
          label: "Action",

          field: "action",

          width: 120,
        },

        
      ],

      rows: this.state.tableRowsProduct,
    };

    const selectedOptionsStyles = {
      color: "#3c763d",
      backgroundColor: "#dff0d8",
    };
    const optionsListStyles = {
      backgroundColor: "#dff0d8",
      color: "#3c763d",
    };

    return (
      <Col xl={12}>
    {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          <CardBody style={{height: 80}}>
            <form className="form form--inline" onSubmit={handleSubmit}>
            
              

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", maxWidth: '20%', flex: '1 0 8.333333%', }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30, }}
                  >
                    <button
                      color="primary"
                      className="btn-sm button_enable "
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",
                        marginLeft: -15,
                        width : 110

                      }}
                      id="button_enable"
                      onClick={this.onCreate}
                    >
                      {this.state.genloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Create New
                    </button>
                  </ButtonToolbar>
                </div>
              </div>


              {this.state.showSTNNumber &&
              <div className="form__form-group col-xl-2" style={{maxWidth: '20%', flex: '2 0 8.333333%',}}>
                <div className="form__form-group-field"><span style={{marginTop: 6}}>STM Number : {this.state.generated_stn_number} </span></div>
              </div>
              }

             
            </form>
          </CardBody>

          {this.state.showDashboardData && (
            <CardBody style={{ marginTop: 20 }}>
             
               <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex" , float: 'left', width: '15%' }}
              >
                <div
                  className="form__form-group-field col-xl-6"
                  style={{ display: "contents" }}
                >
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30, }}
                  >
                    <button
                      color="primary"
                      disabled= {this.state.showSTNNumber === true ? false : true}
                      className="button_enable "
                      style={{
                        borderRadius: 5,
                        backgroundColor: this.state.showSTNNumber === true ? '#FBBB00': "#c1c1c1",

                        color: "black",
                        marginLeft: -15,
                        paddingLeft: 8,
                        paddingRight: 8,
                        width:110

                      }}
                      id="button_enable"
                      onClick={this.toggleAssignUser}
                    >
                      {this.state.genloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Add Product
                    </button>
                  </ButtonToolbar>
                </div>
              </div>
           
              <div>
             
                  <ButtonToolbar
                    className="form__button-toolbar"
                    style={{ height: 30, }}
                  >
                    <button
                      color="primary"
                      className="btn-secondary-success "
                      style={{
                        borderRadius: 5,
                        backgroundColor: "#70bbfd",
                        color: "#fff",

                      }}
                      id="button_enable"
                      onClick={this.onConfrmStock}
                    >
                      {this.state.genloading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      Create Request
                    </button>
                  </ButtonToolbar>
                
              </div>
              <MDBDataTable
                striped
                bordered
                hover
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'To Dmg/Exp', 'datatable_pagination_change' )}
                data={productData}
                scrollX={true}
              />
            </CardBody>
          )}
      
      <div className="row">
            {this.state.showProcess && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showProcess && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Selection Mode
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={[{"label":"Cycle Count by Bin","value":"1"},{"label":"Cycle Count by Area","value":"2"}]}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onSelectProcess}
                          value={this.state.selectedProcess}
                        />
                      </div>
                    </div>
                  )}

                </CardBody>
              </div>
            )}
          </div>
    
      {this.state.showBinAddressDropdown && (
            <div class="row">
              <div className="col-xl-12" style={{marginBottom:20}}>
                <CardBody style={{ marginTop: 20 }}>
                  
                  <div
                    className="form__form-group col-xl-12"
                    style={{ display: "inline-flex", marginTop: "10px",marginBottom:'0px' }}
                  >
                    <span
                      className="form__form-group-label col-xl-3"
                      style={{
                        display: "inline",
                        paddingTop: 6,
                        paddingBottom: 6,
                      }}
                    >
                      Bin Address
                    </span>

                    <div
                      className="form__form-group-field col-xl-9"
                      style={{ display: "inline" }}
                    >
                      <input
                        placeholder="Select Bin Address"
                        type="text"
                        style={{
                          padding: 10,
                          borderRadius: 4,
                          width: "100%",
                          fontSize: 13,borderColor: 'hsl(0,0%,80%)',borderStyle: 'solid',borderWidth: '1px'
                        }}
                        value={this.state.selectedBinAddress}
                        onChange={this.onBinAddressKeyup}
                        onBlur={this.onBlurBinAddress}
                      />

                      {this.state.containerOnKeyDown && (
                        <div
                          className="suggestions-container"
                          style={{ height: 150, width: "100%" }}
                          ref={(el) => (this.typeahead = el)}
                        >
                          <div className="suggestions">
                            {this.state.optionForBinAddressDropdown.length >
                              0 &&
                              this.state.optionForBinAddressDropdown.map(
                                (item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.onSelectBinAddress([item])
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.label}{" "}
                                  </p>
                                )
                              )}
                          </div>
                        </div>
                      )}

                      
                    </div>
                  </div>
                </CardBody>
              </div>
            </div>
          )}
  
    
          <div className="row">
            {this.state.showZone && (
              <div className="col-xl-12" style={{ marginBottom: 20}}>
                <CardBody style={{ marginTop: 20}}>
                  
                  {this.state.showZone && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex", marginTop: "10px" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Zone
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={options}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal3}
                          allowSelectAll={true}
                          value={this.state.optionSelected}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showAisle && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Aisle{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options1}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal1}
                          allowSelectAll={true}
                          value={this.state.optionSelected1}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showRack && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <span
                        className="form__form-group-label col-xl-3"
                        style={{
                          display: "inline",
                          paddingTop: 6,
                          paddingBottom: 6,
                        }}
                      >
                        Rack{" "}
                      </span>

                      <div
                        className="form__form-group-field col-xl-9"
                        style={{ display: "inline" }}
                      >
                        <MySelect
                          style={{ width: "100%" }}
                          options={this.state.options2}
                          isMulti
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={this.onChangeVal2}
                          allowSelectAll={true}
                          value={this.state.optionSelected2}
                        />
                      </div>
                    </div>
                  )}

                  {this.state.showSubmitBtn && (
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex" }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            disabled={this.state.disabledBtn}
                            className="btn-sm show_confirm_button"
                            onClick={this.onSubmitCycleCount}
                            type="submit"
                          >
                            {this.state.loadBinData && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                            Submit
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  )}
                </CardBody>
              </div>
            )}
          </div>
      
          {this.state.showSelectedBin && (
            <CardBody style={{ marginTop: 20 }}>
              <div style={{ width: "100%", marginBottom: 8 }}>
                <span style={{ fontWeight: "bold", fontSize: 15 }}>
                  {" "}
                  Selected Bins ({this.state.SelectedBins.length}){" "}
                </span>
              </div>

              <div style={{ width: "100%" }}>
                {this.state.binData.map(
                  (item, index) =>
                    item.isChecked == true && (
                      <span
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          fontSize: 13,
                          width: "14%",
                          float: "left",
                          backgroundColor: "#ccc",
                          borderRadius: 6,
                          paddingTop: 4,
                          paddingBottom: 4,
                          marginRight: 8,
                          marginBottom: 5,
                        }}
                      >
                        {" "}
                        {item.bin_address}{" "}<a><i onClick={() => this.removeBin(item.bin_address)}class="fa fa-times" aria-hidden="true" style={{float: 'right', paddingRight: '10px', paddingTop: '4px'}}></i></a>
                      </span>
                    )
                )}
              </div>
        
        {this.state.isdisableBinAssignBtn &&
                    <div
                      className="form__form-group col-xl-12"
                      style={{ display: "inline-flex",margin: '20px 0px',paddingLeft: '0px' }}
                    >
                      <div
                        className="form__form-group-field col-xl-12"
                        style={{ display: "contents", textAlign: "center" }}
                      >
                        <ButtonToolbar className="form__button-toolbar">
                          <Button
                            color="primary"
                            className="btn-sm show_confirm_button"
                            onClick={this.AssignUser}
                            type="submit"
                          >
                            Assign
                          </Button>
                        </ButtonToolbar>
                      </div>
                    </div>
                  }
            </CardBody>
          )}

         
          {this.state.showBinTable && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.AssignUser}
                    type="submit"
                    disabled={this.state.isdisableAssignBtn}
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Assign
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={this.state.isChecked}
                        onChange={() => this.checkAll()}
                      />{" "}
                    </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.binData.length > 0 &&
                    this.state.binData.map((item, index) => (
                      <tr>
                        <td>
                          {" "}
                          <input
                            type="checkbox"
                            value={item.isChecked}
                            checked={item.isChecked}
                            onChange={() => this.checkedSingle(index, item)}
                          />{" "}
                        </td>
                        <td> {item.bin_address} </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </CardBody>
          )}

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <span>
                  {" "}
                  <span style={{ fontWeight: "bold" }}> GRN Number: </span>{" "}
                  <span> {this.state.grnValues} / </span>{" "}
                  <span style={{ fontWeight: "bold" }}> GRN Line Number: </span>{" "}
                  <span> {this.state.grnLineValue} </span>
                </span>

                <ButtonToolbar className="form__button-toolbar">
                  {this.state.showAssignButton && (
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.toggle}
                      type="submit"
                    >
                      Assign
                    </Button>
                  )}
                  {this.state.showPrintButton && (
                    <Button color="primary" className="btn-sm" type="submit">
                      Print
                    </Button>
                  )}
                </ButtonToolbar>
              </div>

              <div className="table_val">
              </div>
            </CardBody>
          )}

          {this.state.showFailedItem && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className="btn-sm show_confirm_button"
                    onClick={this.confirmData}
                    type="submit"
                  >
                    {this.state.loadingconfirmbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </Button>
                </ButtonToolbar>
              </div>
              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>Response </th>
                    <th>Bin Address</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.FailedItems.map((item, index) => (
                    <tr>
                      <td style={{ backgroundColor: "red", color: "#fff" }}>
                        {" "}
                        {item.reason}{" "}
                      </td>

                      <td>{item.bin_address}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modalAssignUser}
          toggle={this.toggleAssignUser}
          style={{ maxWidth: 920, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Add Product
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div style={{width: '100%', float: 'left', marginTop: 30, marginBottom: 20}}>
            <div
                className="form__form-group "
                style={{ marginBottom: "0px",width: '26%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '34%', float: 'left'}} for="item_code">Prod Code</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input  type = "text" name="prod_code" value={this.state.prod_code} className="form-control group_text_2" placeholder= "Prod code" onChange={(evt) =>this.onHandleChange(evt)}/>
                  </div>
                </div>
              </div>

              <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '24%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <label style={{marginTop: 5,width: '30%', float: 'left'}} for="item_code">Mrp</label>
                   <div style={{width: '60%', float: 'left'}}>
                   <input  type = "text" name="mrp" value={this.state.mrp} className="form-control group_text_2" placeholder= "Mrp " onChange={(evt) =>this.onHandleChange(evt)}/>
                  </div>
                </div>
              </div>

               <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '13%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                 <ButtonToolbar className="modal__footer">
                  <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.onSearchData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Search
              </Button>
               </ButtonToolbar>
                </div>
              </div>

              {this.state.validProd == true &&
                <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '6%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <i style={{color: '#24d6a3', marginTop: 5}} class="fa fa-check" aria-hidden="true">Valid</i>
                </div>
                </div>
              }

              {this.state.notvalidProd == true &&
                <div
                className="form__form-group "
                style={{ marginBottom: "0px", width: '6%', float: 'left'}}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <i style={{color: 'red'}} class="fa fa-times" aria-hidden="true">Invalid</i>
                </div>
                </div>
              }
              </div>

              <hr id="divider"/>

               <div style={{ width: "100%", float: "left", marginTop: 20, paddingLeft: 12 }}>

               
                <div
                  className="form__form-group-field" style={{width: '15%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">From Loc</label>
                   
                   {/*<input  type = "text"  name="prod_code" disabled value={this.state.from_loc_val} className="form-control stock_text_styling" placeholder= "From Loc" onChange={this.onHandleChange}/>*/}
                  
                   <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 132 }}
                    onChange={(evt) =>this.onHandleChange(evt)}
                    name="from_loc"
                    value= {this.state.from_loc}

                  >
                    
                    {
                      this.state.from_loc_data.length > 0 &&
                      this.state.from_loc_data.map((data) => {
                        return (
                          <option value={data.zone_type}> {data.type_desc}</option>
                        );
                      })}
                  </select>

                </div>

                <div
                  className="form__form-group-field" style={{width: '18%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">From Bin</label>
                   
                   {/*<input  type = "text"  name="prod_code" disabled value={this.state.from_loc_val} className="form-control stock_text_styling" placeholder= "From Loc" onChange={this.onHandleChange}/>*/}
                  
                   <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 145 }}
                    onChange={(evt) =>this.onHandleChangeBin(evt)}
                    name="from_bin_id"
                    value= {this.state.from_bin_id}

                  >
                    
                    {
                      this.state.from_bin_data.length > 0 &&
                      this.state.from_bin_data.map((data) => {
                        return (
                          <option value={data.id}> {data.bin_address}</option>
                        );
                      })}
                  </select>

                </div>
             

              
                <div
                  className="form__form-group-field" style={{width: '16%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">To Loc</label>
                   
                   {/*<input  type = "text" name="prod_code" disabled value={this.state.to_loc_val} className="form-control stock_text_styling" placeholder= "Prod code" onChange={this.onHandleChange}/>*/}
                    <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 132 }}
                    /*onChange={this.onHandleChange}*/onHandleChange
                     onChange={(evt) =>this.onHandleChange(evt)}
                     value={this.state.to_loc}
                   

                    name="to_loc"
                  >
                    {
                      this.state.to_loc_data.length > 0 &&
                      this.state.to_loc_data.map((data) => {
                        return (
                          <option value={data.zone_type}> {data.type_desc}</option>
                        );
                      })}
                  </select>

                </div>

                 <div
                  className="form__form-group-field" style={{width: '17%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">To Bin</label>
                   
                   {/*<input  type = "text" name="prod_code" disabled value={this.state.to_loc_val} className="form-control stock_text_styling" placeholder= "Prod code" onChange={this.onHandleChange}/>*/}
                    <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 145 }}
                    /*onChange={this.onHandleChange}*/
                     onChange={(evt) =>this.onHandleChangeBin(evt)}
                     value={this.state.to_bin_id}
                   

                    name="to_bin_id"
                  >
                    {
                      this.state.to_bin_data.length > 0 &&
                      this.state.to_bin_data.map((data) => {
                        return (
                          <option value={data.id}> {data.bin_address }</option>
                        );
                      })}
                  </select>

                </div>
              

                 <div
                  className="form__form-group-field" style={{width: '15%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">Qty</label>
                   
                   <input  type = "text" name="prod_code" className="form-control stock_text_styling" name="qty" placeholder= "Qty"  onChange={(evt) =>this.onHandleChange(evt)}/>
                  
                </div>

                 <div
                  className="form__form-group-field" style={{width: '18%', float: 'left', flexDirection: 'column',}}
                  
                >
                  <label style={{marginTop: 5, textAlign: 'left'}} for="item_code">Reason</label>
                   
                   <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 145 }}
                    onChange={(evt) =>this.onHandleChange(evt)}
                    name="reason"
                  >
                    <option value="">Select Reason</option>
                    {
                      this.state.reasonData.length > 0 &&
                      this.state.reasonData.map((reasonData) => {
                        return (
                          <option value={reasonData.id}> {reasonData.name}</option>
                        );
                      })}
                  </select>
                  
                </div>

               </div>




              
               <div style={{ width: "100%", float: "left", marginTop: 20 }}>

            <ButtonToolbar className="modal__footer">
              <Button

                id="btn-secondary-cancel"
                onClick={this.toggleAssignUser}
              >
                Cancel
              </Button>
              <button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="btn-secondary-success"
                onClick={this.addProduct}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin "
                    style={{ marginRight: "5px" }}
                  />
                )}
                Add
              </button>
            </ButtonToolbar>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalAssignUserCycleCount}
          toggle={this.toggleAssignUserCycleCount}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <div>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>
                {" "}
                Estimated Scan Count :{" "}
                <span style={{ color: "red" }}>
                  {" "}
                  {this.state.totalScanCount}{" "}
                </span>{" "}
              </span>
            </div>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>Zone Id</th>
                  <th>Zone Name</th>
                  <th> Bin Count </th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(uniqueZoneData1).length > 0 &&
                  _.map(uniqueZoneData1, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>{item.items.length} </td>
                      <td>
                        <div
                          className="form__form-group"
                          style={{ width: "100%" }}
                        >
                          <div
                            style={{ width: "100%" }}
                            className="form__form-group-field"
                          >
                            <MySelect
                              style={{ width: "100%" }}
                              isMulti
                              name={`multiSelect_${item.zoneId}`}
                              value={selectedUser[item.zoneId]}
                              onChange={(selectedOptions) =>
                                this.onChangeVal(
                                  selectedOptions,
                                  item.zoneId,
                                  item.items
                                )
                              }
                              options={optionsUser}
                              clearable={true}
                              closeOnSelect={true}
                              removeSelected={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.toggleAssignUserCycleCount}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData1}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Assign Users
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <form className="form form--inline">
              <div
                className="form__form-group col-xl-10"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{
                    display: "inline",
                    paddingTop: 6,
                    paddingBottom: 6,
                    fontWeight: "bold",
                  }}
                >
                  Select User
                </span>

                <div
                  className="form__form-group-field col-xl-7"
                  style={{ display: "contents" }}
                >
                  <Field
                    name="select"
                    label="Select"
                    component={renderSelectField}
                    placeholder="Select User"
                    onChange={this.change1}
                    options={[
                      { value: "user1", label: "WMS User" },
                      { value: "test", label: "Test User" },
                    ]}
                  />
                </div>
              </div>

              <div className="form__form-group col-xl-3">
                <div className="form__form-group-field"></div>
              </div>
            </form>

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.togglePressCancel}
              >
                Cancel
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                {this.state.loadingprintbtn && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={successModal} toggle={this.successToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={successMessageModal} toggle={this.successMessageToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.successMessageToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4>{this.state.success_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.successMessageToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModal} toggle={this.messagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.toggle}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModal}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={cycleCountCancelModal} toggle={this.onCancelCycleModal}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancelCycleModal}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.onCancelCycleModal}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.onCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={messageModalCycle} toggle={this.messageToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.messageToggleCycle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff", marginRight: 8 }}
              className="modal_ok"
              onClick={this.messageToggleCycle}
            >
              Cancel
            </Button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelMessageModalCycle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailed} toggle={this.failedToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15, }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.failedToggleCancel}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalCancel} toggle={this.cancelToggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.cancelToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.cancelReason} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.cancelToggle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={modalfailedCycle} toggle={this.failedToggleCycle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.failedToggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> {this.state.failedMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.failedToggleCancelCycle}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalReport}
          toggle={this.toggleReports}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Download Reports
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%" }}>
                <tr>
                  <td>SKU Level and PKM level Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadSKU}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Physical Excess Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadExcessStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td>Complete Stock Report</td>

                  <td>
                    <span
                      style={{
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontSize: 15,
                        color: "rgb(112, 187, 253)",
                      }}
                      onClick={this.downloadCompleteStock}
                    >
                      {" "}
                      Export to Excel{" "}
                    </span>
                  </td>
                </tr>

                <tr>
                  <td colspan="2" style={{ textAlign: "center" }}>
                    <ButtonToolbar
                      className="modal__footer"
                      style={{ paddingTop: 12, paddingBottom: 20 }}
                    >
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.closeReportModal}
                      >
                        Cancel
                      </Button>
                    </ButtonToolbar>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));